export const PAGE_CONFIG = {
  "title": "Realtime Users",
  "titleCN": "实时用户",
  "subTitle": "Timezone (UTC{{timeZone}})",
  "subTitleCN": "时区 (UTC{{timeZone}})",
  "path": "/realtime/nightingaleUsers",
  "defaultTab": "users",
  "tabList": [
    {
      "id": "users",
      "tabName": "Users",
      "tabNameCN": "用户",
      "isHaveNotification": true,
      "refresh": true,
      "notificationPath": "/realtime/nightingaleUsers/users",
      "path": "/realtime/nightingaleUsers",
      "tabIcon": "",
      "logConfig": {
        "pageId": "203201",
        "pageName": "realtimeNightingaleRealtimeUsersUsers",
        "extInfo": "realtimeNightingaleRealtimeUsersUsers",
        "pagePath": "/realtime/nightingaleUsers/users"
      },
      "filters": [
        {
          "name": "realtimeUserFilter",
          "isOpenSticky": false,
          "isHaveFilterSave": true,
          "filterPath": "/realtime/nightingaleUsers/users",
          "componentList": [
            {
              "name": "realtimeUserService",
              "className": "",
              "type": "view",
              "style": {},
              "props": {
                "config": {
                  "api": "/api/v1/dashboard/pc/inflexion/realtime/usertag",
                  "dataKey": "usertag",
                  "isDark": false,
                  "refreshKey": "realtime_user_usertag",
                  "interval": 300000
                }
              },
              "children": [
                {
                  "name": "realtimeUserService",
                  "className": "",
                  "type": "view",
                  "style": {},
                  "props": {
                    "config": {
                      "api": "/api/v1/dashboard/pc/realtime/retention",
                      "dataKey": "retention",
                      "isDark": false,
                      "refreshKey": "realtime_user_retention",
                      "interval": 300000
                    }
                  },
                  "children": [
                    {
                      "name": "realtimeUserService",
                      "className": "",
                      "type": "view",
                      "style": {},
                      "props": {
                        "config": {
                          "api": "/api/v1/dashboard/event_analysis/realtime/date_event_list",
                          "dataKey": "date_event_list",
                          "isDark": false,
                          "refreshKey": "realtime_user_event",
                          "interval": 300000
                        }
                      },
                      "children": [
                        {
                          "name": "MetricsCardTitle",
                          "className": "",
                          "type": "view",
                          "style": {},
                          "props": {
                            "config": {
                              "titleEn": "Realtime Key Metrics",
                              "titleCn": "实时关键指标",
                              "isInflexion": true
                            }
                          }
                        },
                        {
                          "name": "MetricCardCo",
                          "className": "",
                          "type": "view",
                          "style": {},
                          "props": {
                            "config": {}
                          },
                          "children": [
                            {
                              "name": "CommonRow",
                              "className": "",
                              "type": "layout",
                              "style": {},
                              "props": {},
                              "children": [
                                {
                                  "name": "CommonCol",
                                  "className": "",
                                  "type": "layout",
                                  "style": {},
                                  "children": [
                                    {
                                      "name": "MetricsCardContext",
                                      "className": "",
                                      "type": "view",
                                      "style": {},
                                      "props": {
                                        "config": {
                                          "apiDataKey": [
                                            "usertag"
                                          ],
                                          "dataKey": [
                                            "new_users_card",
                                            "active_users_card",
                                            "online_users_card"
                                          ],
                                          "trendDataKey": [
                                            "new_users",
                                            "active_users",
                                            "online_users"
                                          ],
                                          "isRealTime": true,
                                          "isNightingale": true
                                        }
                                      },
                                      "children": [
                                        {
                                          "name": "CommonRow",
                                          "className": "",
                                          "type": "layout",
                                          "style": {},
                                          "props": {},
                                          "children": [
                                            {
                                              "name": "CommonCol",
                                              "className": "",
                                              "type": "layout",
                                              "style": {},
                                              "props": {
                                                "w": 8
                                              },
                                              "children": [
                                                {
                                                  "name": "MetricCard",
                                                  "className": "",
                                                  "style": {},
                                                  "type": "view",
                                                  "props": {
                                                    "config": {
                                                      "componentMetrics": [
                                                        {
                                                          "metricKey": "new_users_card",
                                                          "trendKey": "new_users",
                                                          "enName": "New Users",
                                                          "cnName": "新进用户",
                                                          "rangeEnName": "New Users",
                                                          "rangeCnName": "新进用户",
                                                          "preUnit": "",
                                                          "endUnit": "",
                                                          "rainbowKey": "Pc Metrics New Users",
                                                          "type": "int",
                                                          "decimal": 0,
                                                          "icon": "user-u",
                                                          "position": "",
                                                          "isLeftCard": true
                                                        }
                                                      ]
                                                    },
                                                    "isShowIcon": true
                                                  },
                                                  "children": []
                                                }
                                              ]
                                            },
                                            {
                                              "name": "CommonCol",
                                              "className": "",
                                              "type": "layout",
                                              "style": {},
                                              "props": {
                                                "w": 8
                                              },
                                              "children": [
                                                {
                                                  "name": "MetricCard",
                                                  "className": "",
                                                  "style": {},
                                                  "type": "view",
                                                  "props": {
                                                    "config": {
                                                      "componentMetrics": [
                                                        {
                                                          "metricKey": "active_users_card",
                                                          "trendKey": "active_users",
                                                          "enName": "Active Users",
                                                          "cnName": "活跃用户",
                                                          "rangeEnName": "Active Users",
                                                          "rangeCnName": "活跃用户",
                                                          "preUnit": "",
                                                          "endUnit": "",
                                                          "rainbowKey": "Pc Metrics Active Users",
                                                          "type": "int",
                                                          "decimal": 0,
                                                          "icon": "user-u",
                                                          "position": ""
                                                        }
                                                      ]
                                                    }
                                                  },
                                                  "children": []
                                                }
                                              ]
                                            },
                                            {
                                              "name": "CommonCol",
                                              "className": "",
                                              "type": "layout",
                                              "style": {},
                                              "props": {
                                                "w": 8
                                              },
                                              "children": [
                                                {
                                                  "name": "MetricCard",
                                                  "className": "",
                                                  "style": {},
                                                  "type": "view",
                                                  "props": {
                                                    "config": {
                                                      "componentMetrics": [
                                                        {
                                                          "metricKey": "online_users_card",
                                                          "trendKey": "online_users",
                                                          "enName": "Concurrent Users",
                                                          "cnName": "在线用户",
                                                          "rangeEnName": "Concurrent Users",
                                                          "rangeCnName": "在线用户",
                                                          "preUnit": "",
                                                          "endUnit": "",
                                                          "rainbowKey": "Pc Metrics Online Users",
                                                          "type": "int",
                                                          "decimal": 0,
                                                          "icon": "user-u",
                                                          "position": ""
                                                        }
                                                      ]
                                                    }
                                                  },
                                                  "children": []
                                                }
                                              ]
                                            }
                                          ]
                                        }
                                      ]
                                    }
                                  ]
                                }
                              ]
                            }
                          ]
                        },
                        {
                          "name": "SegmentScrollCo",
                          "className": "margin-t-20",
                          "style": {},
                          "type": "view",
                          "props": {
                            "config": {
                              "componentSegment": [
                                {
                                  "value": "1",
                                  "enName": "New",
                                  "cnName": "新进用户",
                                  "disable": false,
                                  "rainbowKey": "",
                                  "enTooltip": "",
                                  "cntooltip": ""
                                },
                                {
                                  "value": "2",
                                  "enName": "Active",
                                  "cnName": "活跃用户",
                                  "rainbowKey": "",
                                  "disable": false,
                                  "enTooltip": "",
                                  "cntooltip": ""
                                },
                                {
                                  "value": "3",
                                  "enName": "CCU",
                                  "cnName": "在线用户",
                                  "rainbowKey": "",
                                  "disable": false,
                                  "enTooltip": "",
                                  "cntooltip": ""
                                }
                              ],
                              "scrollMarginTop": "75px"
                            }
                          },
                          "children": [
                            {
                              "name": "RealtimeRentationContext",
                              "props": {
                                "config": {
                                  "title": "Realtime Daily Accumulated New Users (5 min)",
                                  "titleCn": "新进用户",
                                  "formatTitle": "realtime_users_new_title",
                                  "apiDataKey": "usertag",
                                  "dataKey": "new_users",
                                  "dataType": "",
                                  "table": {
                                    "option": [
                                      {
                                        "key": "time",
                                        "align": "left",
                                        "fixed": "left",
                                        "width": 100,
                                        "title": "Time",
                                        "titleCn": "时间",
                                        "formatTitle": "realtime_by_country_table_time",
                                        "valueKey": "time"
                                      },
                                      {
                                        "key": "line_dot",
                                        "align": "right",
                                        "fixed": "",
                                        "width": 100,
                                        "title": "Today {{singleDaily|date|YYYY-MM-DD}}",
                                        "titleCn": "今天 {{singleDaily|date|YYYY-MM-DD}}",
                                        "valueKey": "lineDot",
                                        "format": "#,##0",
                                        "type": "number"
                                      },
                                      {
                                        "key": "line_dot_last",
                                        "align": "right",
                                        "fixed": "",
                                        "width": 100,
                                        "title": "Yesterday {{singleDaily|date|YYYY-MM-DD|-1|day}}",
                                        "titleCn": "昨天 {{singleDaily|date|YYYY-MM-DD|-1|day}}",
                                        "valueKey": "lineDotLast",
                                        "format": "#,##0",
                                        "type": "number"
                                      },
                                      {
                                        "key": "line_dot_contrast",
                                        "align": "right",
                                        "fixed": "",
                                        "width": 100,
                                        "title": "Same Day Last Week {{contrastDaily|date|YYYY-MM-DD}} Contrast Day",
                                        "titleCn": "上周同期 {{contrastDaily|date|YYYY-MM-DD}} 对比日",
                                        "valueKey": "lineDotContrast",
                                        "changeDateTitle": "Contrast Day {{contrastDaily|date|YYYY-MM-DD}}",
                                        "changeDateTitleCn": "对比日 {{contrastDaily|date|YYYY-MM-DD}}",
                                        "format": "#,##0",
                                        "type": "number"
                                      }
                                    ],
                                    "sort": true,
                                    "columns": [
                                      "time"
                                    ],
                                    "defaultValue": [
                                      {
                                        "by": "time",
                                        "order": "desc"
                                      }
                                    ],
                                    "isRealTime": true,
                                    "height": 400
                                  },
                                  "subTitle": [
                                    {
                                      "title": "DoD",
                                      "titleCn": "日环比",
                                      "formatTitle": "",
                                      "valueKey": "dod",
                                      "unit": "percent",
                                      "bold": true
                                    },
                                    {
                                      "title": "SDLW",
                                      "titleCn": "上周同期",
                                      "formatTitle": "",
                                      "valueKey": "sdlw",
                                      "unit": "percent",
                                      "bold": true
                                    }
                                  ],
                                  "event": {
                                    "show": true,
                                    "link": "eventAnalysis/eventDetails",
                                    "dataKey": "date_event_list",
                                    "valueKey": "new_users",
                                    "timeType": "Hour",
                                    "cssStyle": {
                                      "top": "82%"
                                    }
                                  },
                                  "chart": {
                                    "type": "line",
                                    "series": [
                                      {
                                        "valueKey": "line_dot",
                                        "title": "Today {{singleDaily|date|YYYY-MM-DD}}",
                                        "titleCn": "今天 {{singleDaily|date|YYYY-MM-DD}}"
                                      },
                                      {
                                        "valueKey": "line_dot_last",
                                        "title": "Yesterday {{singleDaily|date|YYYY-MM-DD|-1|day}}",
                                        "titleCn": "昨天 {{singleDaily|date|YYYY-MM-DD|-1|day}}"
                                      },
                                      {
                                        "valueKey": "line_dot_contrast",
                                        "title": "Same Day Last Week {{contrastDaily|date|YYYY-MM-DD}} (Contrast Day)",
                                        "titleCn": "上周同期 {{contrastDaily|date|YYYY-MM-DD}} (对比日)",
                                        "changeDateTitle": "Contrast Day {{contrastDaily|date|YYYY-MM-DD}}",
                                        "changeDateTitleCn": "对比日 {{contrastDaily|date|YYYY-MM-DD}}"
                                      }
                                    ],
                                    "tooltip": {
                                      "title": "New Users",
                                      "titleCn": "新进用户",
                                      "formatTitle": "realtime_users_new_users_card_title"
                                    }
                                  },
                                  "download": {
                                    "fileName": "Realtime Daily Accumulated New Users (5 min)",
                                    "fileNameCn": "新进用户",
                                    "formatFileName": "realtime_users_new_title",
                                    "default": "5",
                                    "title": "Time",
                                    "titleCn": "时间粒度",
                                    "formatTitle": "realtime_info_download_time",
                                    "type": [
                                      {
                                        "title": "By hour",
                                        "titleCn": "下载逐小时数据",
                                        "formatTitle": "realtime_info_download_by_hour",
                                        "name": "60",
                                        "disable": "l1h",
                                        "beforeDownload": "hourDownload"
                                      },
                                      {
                                        "title": "By 5 min",
                                        "titleCn": "下载每5 min数据",
                                        "formatTitle": "realtime_info_download_by_5_min",
                                        "name": "5",
                                        "beforeDownload": ""
                                      }
                                    ],
                                    "sorting": false,
                                    "sort": "desc"
                                  }
                                }
                              },
                              "id": 1
                            },
                            {
                              "name": "RealtimeRentationContext",
                              "props": {
                                "config": {
                                  "title": "Realtime Daily Accumulated Active Users (5 min)",
                                  "titleCn": "活跃用户",
                                  "formatTitle": "realtime_users_active_users_card_title",
                                  "apiDataKey": "usertag",
                                  "dataKey": "active_users",
                                  "dataType": "",
                                  "table": {
                                    "option": [
                                      {
                                        "key": "time",
                                        "align": "left",
                                        "fixed": "left",
                                        "width": 100,
                                        "title": "Time",
                                        "titleCn": "时间",
                                        "formatTitle": "realtime_by_country_table_time",
                                        "valueKey": "time"
                                      },
                                      {
                                        "key": "line_dot",
                                        "align": "right",
                                        "fixed": "",
                                        "width": 100,
                                        "title": "Today {{singleDaily|date|YYYY-MM-DD}}",
                                        "titleCn": "今天 {{singleDaily|date|YYYY-MM-DD}}",
                                        "valueKey": "lineDot",
                                        "format": "#,##0",
                                        "type": "number"
                                      },
                                      {
                                        "key": "line_dot_last",
                                        "align": "right",
                                        "fixed": "",
                                        "width": 100,
                                        "title": "Yesterday {{singleDaily|date|YYYY-MM-DD|-1|day}}",
                                        "titleCn": "昨天 {{singleDaily|date|YYYY-MM-DD|-1|day}}",
                                        "valueKey": "lineDotLast",
                                        "format": "#,##0",
                                        "type": "number"
                                      },
                                      {
                                        "key": "line_dot_contrast",
                                        "align": "right",
                                        "fixed": "",
                                        "width": 100,
                                        "title": "Same Day Last Week {{contrastDaily|date|YYYY-MM-DD}} Contrast Day",
                                        "titleCn": "上周同期 {{contrastDaily|date|YYYY-MM-DD}} 对比日",
                                        "valueKey": "lineDotContrast",
                                        "changeDateTitle": "Contrast Day {{contrastDaily|date|YYYY-MM-DD}}",
                                        "changeDateTitleCn": "对比日 {{contrastDaily|date|YYYY-MM-DD}}",
                                        "format": "#,##0",
                                        "type": "number"
                                      }
                                    ],
                                    "sort": true,
                                    "columns": [
                                      "time"
                                    ],
                                    "defaultValue": [
                                      {
                                        "by": "time",
                                        "order": "desc"
                                      }
                                    ],
                                    "isRealTime": true,
                                    "height": 400
                                  },
                                  "subTitle": [
                                    {
                                      "title": "DoD",
                                      "titleCn": "日环比",
                                      "formatTitle": "",
                                      "valueKey": "dod",
                                      "unit": "percent",
                                      "bold": true
                                    },
                                    {
                                      "title": "SDLW",
                                      "titleCn": "上周同期",
                                      "formatTitle": "",
                                      "valueKey": "sdlw",
                                      "unit": "percent",
                                      "bold": true
                                    }
                                  ],
                                  "event": {
                                    "show": true,
                                    "link": "eventAnalysis/eventDetails",
                                    "dataKey": "date_event_list",
                                    "valueKey": "active_users",
                                    "timeType": "Hour",
                                    "cssStyle": {
                                      "top": "82%"
                                    }
                                  },
                                  "chart": {
                                    "type": "line",
                                    "series": [
                                      {
                                        "valueKey": "line_dot",
                                        "title": "Today {{singleDaily|date|YYYY-MM-DD}}",
                                        "titleCn": "今天 {{singleDaily|date|YYYY-MM-DD}}"
                                      },
                                      {
                                        "valueKey": "line_dot_last",
                                        "title": "Yesterday {{singleDaily|date|YYYY-MM-DD|-1|day}}",
                                        "titleCn": "昨天 {{singleDaily|date|YYYY-MM-DD|-1|day}}"
                                      },
                                      {
                                        "valueKey": "line_dot_contrast",
                                        "title": "Same Day Last Week {{contrastDaily|date|YYYY-MM-DD}} (Contrast Day)",
                                        "titleCn": "上周同期 {{contrastDaily|date|YYYY-MM-DD}} (对比日)",
                                        "changeDateTitle": "Contrast Day {{contrastDaily|date|YYYY-MM-DD}}",
                                        "changeDateTitleCn": "对比日 {{contrastDaily|date|YYYY-MM-DD}}"
                                      }
                                    ],
                                    "tooltip": {
                                      "title": "Active Users",
                                      "titleCn": "活跃用户",
                                      "formatTitle": "realtime_users_active_users_card_title"
                                    }
                                  },
                                  "download": {
                                    "fileName": "Realtime Daily Accumulated Active Users (5 min)",
                                    "fileNameCn": "活跃用户",
                                    "formatFileName": "realtime_users_active_users_card_title",
                                    "default": "5",
                                    "title": "Time",
                                    "titleCn": "时间粒度",
                                    "formatTitle": "realtime_info_download_time",
                                    "type": [
                                      {
                                        "title": "By hour",
                                        "titleCn": "下载逐小时数据",
                                        "formatTitle": "realtime_info_download_by_hour",
                                        "name": "60",
                                        "disable": "l1h",
                                        "beforeDownload": "hourDownload"
                                      },
                                      {
                                        "title": "By 5 min",
                                        "titleCn": "下载每5 min数据",
                                        "formatTitle": "realtime_info_download_by_5_min",
                                        "name": "5",
                                        "beforeDownload": ""
                                      }
                                    ],
                                    "sorting": false,
                                    "sort": "desc"
                                  }
                                }
                              },
                              "id": 2
                            },
                            {
                              "name": "RealtimeRentationContext",
                              "props": {
                                "config": {
                                  "title": "Realtime Concurrent Users (5 min)",
                                  "titleCn": "在线用户",
                                  "formatTitle": "realtime_users_online_users_card_title",
                                  "apiDataKey": "usertag",
                                  "dataKey": "online_users",
                                  "dataType": "",
                                  "table": {
                                    "option": [
                                      {
                                        "key": "time",
                                        "align": "left",
                                        "fixed": "left",
                                        "width": 100,
                                        "title": "Time",
                                        "titleCn": "时间",
                                        "formatTitle": "realtime_by_country_table_time",
                                        "valueKey": "time"
                                      },
                                      {
                                        "key": "line_dot",
                                        "align": "right",
                                        "fixed": "",
                                        "width": 100,
                                        "title": "Today {{singleDaily|date|YYYY-MM-DD}}",
                                        "titleCn": "今天 {{singleDaily|date|YYYY-MM-DD}}",
                                        "valueKey": "lineDot",
                                        "format": "#,##0",
                                        "type": "number"
                                      },
                                      {
                                        "key": "line_dot_last",
                                        "align": "right",
                                        "fixed": "",
                                        "width": 100,
                                        "title": "Yesterday {{singleDaily|date|YYYY-MM-DD|-1|day}}",
                                        "titleCn": "昨天 {{singleDaily|date|YYYY-MM-DD|-1|day}}",
                                        "valueKey": "lineDotLast",
                                        "format": "#,##0",
                                        "type": "number"
                                      },
                                      {
                                        "key": "line_dot_contrast",
                                        "align": "right",
                                        "fixed": "",
                                        "width": 100,
                                        "title": "Same Day Last Week {{contrastDaily|date|YYYY-MM-DD}} Contrast Day",
                                        "titleCn": "上周同期 {{contrastDaily|date|YYYY-MM-DD}} 对比日",
                                        "valueKey": "lineDotContrast",
                                        "changeDateTitle": "Contrast Day {{contrastDaily|date|YYYY-MM-DD}}",
                                        "changeDateTitleCn": "对比日 {{contrastDaily|date|YYYY-MM-DD}}",
                                        "format": "#,##0",
                                        "type": "number"
                                      }
                                    ],
                                    "sort": true,
                                    "columns": [
                                      "time"
                                    ],
                                    "defaultValue": [
                                      {
                                        "by": "time",
                                        "order": "desc"
                                      }
                                    ],
                                    "isRealTime": true,
                                    "height": 400
                                  },
                                  "subTitle": [
                                    {
                                      "title": "DoD",
                                      "titleCn": "日环比",
                                      "formatTitle": "",
                                      "valueKey": "dod",
                                      "unit": "percent",
                                      "bold": true
                                    },
                                    {
                                      "title": "SDLW",
                                      "titleCn": "上周同期",
                                      "formatTitle": "",
                                      "valueKey": "sdlw",
                                      "unit": "percent",
                                      "bold": true
                                    }
                                  ],
                                  "event": {
                                    "show": true,
                                    "link": "eventAnalysis/eventDetails",
                                    "dataKey": "date_event_list",
                                    "valueKey": "online_users",
                                    "timeType": "Hour",
                                    "cssStyle": {
                                      "top": "unset",
                                      "bottom": "20%"
                                    }
                                  },
                                  "chart": {
                                    "type": "line",
                                    "series": [
                                      {
                                        "valueKey": "line_dot",
                                        "title": "Today {{singleDaily|date|YYYY-MM-DD}}",
                                        "titleCn": "今天 {{singleDaily|date|YYYY-MM-DD}}"
                                      },
                                      {
                                        "valueKey": "line_dot_last",
                                        "title": "Yesterday {{singleDaily|date|YYYY-MM-DD|-1|day}}",
                                        "titleCn": "昨天 {{singleDaily|date|YYYY-MM-DD|-1|day}}"
                                      },
                                      {
                                        "valueKey": "line_dot_contrast",
                                        "title": "Same Day Last Week {{contrastDaily|date|YYYY-MM-DD}} (Contrast Day)",
                                        "titleCn": "上周同期 {{contrastDaily|date|YYYY-MM-DD}} (对比日)",
                                        "changeDateTitle": "Contrast Day {{contrastDaily|date|YYYY-MM-DD}}",
                                        "changeDateTitleCn": "对比日 {{contrastDaily|date|YYYY-MM-DD}}"
                                      }
                                    ],
                                    "tooltip": {
                                      "title": "Concurrent Users",
                                      "titleCn": "在线用户",
                                      "formatTitle": "realtime_users_online_users_card_title"
                                    }
                                  },
                                  "download": {
                                    "fileName": "Realtime Concurrent Users (5 min)",
                                    "fileNameCn": "在线用户",
                                    "formatfileName": "realtime_users_online_users_card_title",
                                    "default": "5",
                                    "title": "Time",
                                    "titleCn": "时间粒度",
                                    "formatTitle": "realtime_info_download_time",
                                    "type": [
                                      {
                                        "title": "By hour",
                                        "titleCn": "下载逐小时数据",
                                        "formatTitle": "realtime_info_download_by_hour",
                                        "name": "60",
                                        "disable": "l1h",
                                        "beforeDownload": "hourDownload"
                                      },
                                      {
                                        "title": "By 5 min",
                                        "titleCn": "下载每5 min数据",
                                        "formatTitle": "realtime_info_download_by_5_min",
                                        "name": "5",
                                        "beforeDownload": ""
                                      }
                                    ],
                                    "sorting": false,
                                    "sort": "desc"
                                  }
                                }
                              },
                              "id": 3
                            }
                          ]
                        }
                      ]
                    }
                  ]
                }
              ]
            }
          ]
        }
      ]
    },
    {
      "id": "byCountryRegionZone",
      "tabName": "By Platform/Region/Country",
      "tabNameCN": "分平台/区域/国家",
      "isHaveNotification": true,
      "refresh": true,
      "notificationPath": "/realtime/nightingaleUsers/byCountryRegionZone",
      "path": "/realtime/nightingaleUsers/byCountryRegionZone",
      "tabIcon": "",
      "logConfig": {
        "pageId": "203202",
        "pageName": "realtimeRealtimeUsersByRegionPlatform",
        "extInfo": "realtimeRealtimeUsersByRegionPlatform",
        "pagePath": "/realtime/nightingaleUsers/byCountryRegionZone"
      },
      "filters": [
        {
          "name": "realtimeCountryFilter",
          "isOpenSticky": false,
          "isHaveFilterSave": true,
          "filterPath": "/realtime/nightingaleUsers/byCountryRegionZone",
          "componentList": [
            {
              "name": "realtimeUserService",
              "className": "dbd-daily-card",
              "type": "view",
              "style": {},
              "props": {
                "config": {
                  "api": "/api/v1/dashboard/pc/inflexion/realtime/new_active_online",
                  "dataKey": "country_new_active_online",
                  "isDark": true,
                  "refreshKey": "realtime_country_new_active_online",
                  "interval": 300000
                }
              },
              "data": {
                "dataBy": "country"
              },
              "children": [
                {
                  "name": "CountriesPlatformRegionTab",
                  "className": "",
                  "style": {},
                  "type": "view",
                  "data": {
                    "regionDataType": "country",
                    "isHasBy": true,
                    "tabOrder": [
                      "country",
                      "region",
                      "system"
                    ]
                  },
                  "props": {
                    "config": {
                      "options": [
                        {
                          "text": "By Country",
                          "textCn": "分国家",
                          "formatText": "common_by_Country",
                          "value": "country"
                        },
                        {
                          "text": "By Region",
                          "textCn": "分区域",
                          "formatText": "common_by_Region",
                          "value": "region"
                        },
                        {
                          "text": "By Platform",
                          "textCn": "分平台",
                          "formatText": "common_by_Platform",
                          "value": "system"
                        }
                      ],
                      "defaultValue": "country",
                      "dataKey": "dataBy"
                    }
                  },
                  "children": [
                    {
                      "name": "TrendChartCo",
                      "className": "",
                      "type": "view",
                      "props": {
                        "config": {
                          "title": "Realtime Daily Accumulated New Users (5 min)",
                          "titleCn": "新进用户",
                          "formatTitle": "realtime_by_country_new_title",
                          "dataType": "int",
                          "dataKey": "country_new_active_online",
                          "metricsCardList": {
                            "dataKey": "new_users_info"
                          },
                          "lastTime": {
                            "dataKey": "new_user_last_time"
                          },
                          "chart": {
                            "dataKey": "new_users_top",
                            "tooltip": {
                              "title": "New Users",
                              "titleCn": "新进用户",
                              "formatTitle": "realtime_users_new_users_card_title",
                              "share": true,
                              "shareTitle": "Share",
                              "shareTitleCn": "占比"
                            }
                          },
                          "table": {
                            "dataKey": "new_users_list",
                            "options": [
                              {
                                "key": "time",
                                "align": "left",
                                "width": 100,
                                "title": "Time",
                                "titleCn": "时间",
                                "formatTitle": "realtime_by_country_table_time",
                                "type": "date",
                                "format": "HH:mm"
                              },
                              {
                                "key": "type",
                                "align": "left",
                                "width": 100,
                                "title": "table_{{dataBy}}",
                                "titleCn": "table_{{dataBy}}",
                                "formatTitle": "realtime_by_country_table_{{dataBy}}",
                                "type": "string"
                              },
                              {
                                "key": "value",
                                "align": "right",
                                "width": 100,
                                "title": "New Users",
                                "titleCn": "新进用户",
                                "formatTitle": "realtime_by_country_table_new_users",
                                "type": "number",
                                "format": "#,##0"
                              },
                              {
                                "key": "share",
                                "align": "right",
                                "width": 100,
                                "title": "Share",
                                "titleCn": "占比",
                                "formatTitle": "",
                                "type": "number",
                                "format": "0.0%"
                              }
                            ]
                          },
                          "download": [
                            {
                              "title": "Time",
                              "titleCn": "时间粒度",
                              "formatTitle": "realtime_info_download_time",
                              "defaultValue": "5",
                              "type": [
                                {
                                  "title": "By hour",
                                  "titleCn": "下载逐小时数据",
                                  "formatTitle": "realtime_info_download_by_hour",
                                  "value": "60",
                                  "disabled": false
                                },
                                {
                                  "title": "By 5 min",
                                  "titleCn": "下载每5 min数据",
                                  "formatTitle": "realtime_info_download_by_5_min",
                                  "value": "5",
                                  "disabled": false
                                }
                              ]
                            }
                          ]
                        }
                      }
                    },
                    {
                      "name": "TrendChartCo",
                      "className": "",
                      "type": "view",
                      "props": {
                        "config": {
                          "title": "Realtime Daily Accumulated Active Users (5 min)",
                          "titleCn": "活跃用户",
                          "formatTitle": "realtime_by_country_active_title",
                          "dataType": "int",
                          "dataKey": "country_new_active_online",
                          "metricsCardList": {
                            "dataKey": "active_user_info"
                          },
                          "lastTime": {
                            "dataKey": "active_user_last_time"
                          },
                          "chart": {
                            "dataKey": "active_users_top",
                            "tooltip": {
                              "title": "Active Users",
                              "titleCn": "活跃用户",
                              "formatTitle": "realtime_users_active_users_card_title",
                              "share": true,
                              "shareTitle": "Share",
                              "shareTitleCn": "占比"
                            }
                          },
                          "table": {
                            "dataKey": "active_users_list",
                            "options": [
                              {
                                "key": "time",
                                "align": "left",
                                "width": 100,
                                "title": "Time",
                                "titleCn": "时间",
                                "formatTitle": "realtime_by_country_table_time",
                                "type": "date",
                                "format": "HH:mm"
                              },
                              {
                                "key": "type",
                                "align": "left",
                                "width": 100,
                                "title": "table_{{dataBy}}",
                                "titleCn": "table_{{dataBy}}",
                                "formatTitle": "realtime_by_country_table_{{dataBy}}",
                                "type": "string"
                              },
                              {
                                "key": "value",
                                "align": "right",
                                "width": 100,
                                "title": "Active Users",
                                "titleCn": "活跃用户",
                                "formatTitle": "realtime_by_country_table_active_users",
                                "type": "number",
                                "format": "#,##0"
                              },
                              {
                                "key": "share",
                                "align": "right",
                                "width": 100,
                                "title": "Share",
                                "titleCn": "占比",
                                "formatTitle": "",
                                "type": "number",
                                "format": "0.0%"
                              }
                            ]
                          },
                          "download": [
                            {
                              "title": "Time",
                              "titleCn": "时间粒度",
                              "formatTitle": "realtime_info_download_time",
                              "defaultValue": "5",
                              "type": [
                                {
                                  "title": "By hour",
                                  "titleCn": "下载逐小时数据",
                                  "formatTitle": "realtime_info_download_by_hour",
                                  "value": "60",
                                  "disabled": false
                                },
                                {
                                  "title": "By 5 min",
                                  "titleCn": "下载每5 min数据",
                                  "formatTitle": "realtime_info_download_by_5_min",
                                  "value": "5",
                                  "disabled": false
                                }
                              ]
                            }
                          ]
                        }
                      }
                    },
                    {
                      "name": "TrendChartCo",
                      "className": "",
                      "type": "view",
                      "props": {
                        "config": {
                          "title": "Realtime Concurrent Users(5 min)",
                          "titleCn": "在线用户",
                          "formatTitle": "realtime_by_country_online_title",
                          "dataType": "int",
                          "dataKey": "country_new_active_online",
                          "metricsCardList": {
                            "dataKey": "online_user_info"
                          },
                          "lastTime": {
                            "dataKey": "online_user_last_time"
                          },
                          "chart": {
                            "dataKey": "online_users_top",
                            "tooltip": {
                              "title": "Concurrent Users",
                              "titleCn": "在线用户",
                              "formatTitle": "realtime_users_online_users_card_title",
                              "share": true,
                              "shareTitle": "Share",
                              "shareTitleCn": "占比"
                            }
                          },
                          "table": {
                            "dataKey": "online_users_list",
                            "options": [
                              {
                                "key": "time",
                                "align": "left",
                                "width": 100,
                                "title": "Time",
                                "titleCn": "时间",
                                "formatTitle": "realtime_by_country_table_time",
                                "type": "date",
                                "format": "HH:mm"
                              },
                              {
                                "key": "type",
                                "align": "left",
                                "width": 100,
                                "title": "table_{{dataBy}}",
                                "titleCn": "table_{{dataBy}}",
                                "formatTitle": "realtime_by_country_table_{{dataBy}}",
                                "type": "string"
                              },
                              {
                                "key": "value",
                                "align": "right",
                                "width": 100,
                                "title": "Concurrent Users",
                                "titleCn": "在线用户",
                                "formatTitle": "realtime_by_country_table_online_users",
                                "type": "number",
                                "format": "#,##0"
                              },
                              {
                                "key": "share",
                                "align": "right",
                                "width": 100,
                                "title": "Share",
                                "titleCn": "占比",
                                "formatTitle": "",
                                "type": "number",
                                "format": "0.0%"
                              }
                            ]
                          },
                          "download": [
                            {
                              "title": "Time",
                              "titleCn": "时间粒度",
                              "formatTitle": "realtime_info_download_time",
                              "defaultValue": "5",
                              "type": [
                                {
                                  "title": "By hour",
                                  "titleCn": "下载逐小时数据",
                                  "formatTitle": "realtime_info_download_by_hour",
                                  "value": "60",
                                  "disabled": false
                                },
                                {
                                  "title": "By 5 min",
                                  "titleCn": "下载每5 min数据",
                                  "formatTitle": "realtime_info_download_by_5_min",
                                  "value": "5",
                                  "disabled": false
                                }
                              ]
                            }
                          ]
                        }
                      }
                    }
                  ]
                }
              ]
            }
          ]
        }
      ]
    }
  ]
};